import { Quote } from 'lucide-react';

interface Testimonial {
  quote: string;
  author: string;
  location?: string;
}

interface TestimonialsProps {
  title?: string;
  subtitle?: string;
  testimonials?: Testimonial[];
}

const defaultTestimonials: Testimonial[] = [
  {
    quote: 'Tyche superó todas mis expectativas. El anillo que elegí para mi compromiso es simplemente perfecto. La atención fue excepcional de principio a fin.',
    author: 'María González',
    location: 'Buenos Aires',
  },
  {
    quote: 'El perfume que me recomendaron se convirtió en mi firma personal. Cada vez que lo uso, recibo halagos. Gracias Tyche por entender exactamente lo que buscaba.',
    author: 'Carlos Mendoza',
    location: 'Córdoba',
  },
  {
    quote: 'Compré un collar para mi madre y fue el regalo más especial que le he dado. La calidad es impresionante y el empaque de lujo hizo la experiencia completa.',
    author: 'Luciana Fernández',
    location: 'Rosario',
  },
];

const Testimonials = ({ title, subtitle, testimonials }: TestimonialsProps) => {
  const entries = testimonials ?? defaultTestimonials;
  return (
    <section id="testimonios" className="py-24 lg:py-32 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="font-body text-sm uppercase tracking-[0.3em] text-primary mb-4 block">
            {title ?? 'Testimonios'}
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-6">
            {subtitle ?? 'Lo que dicen nuestros clientes'}
          </h2>
          <div className="line-gold w-24 mx-auto" />
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {entries.map((testimonial, index) => (
            <article
              key={testimonial.author}
              className="card-luxury rounded-lg p-8 relative"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8">
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                  <Quote className="w-5 h-5 text-primary-foreground" />
                </div>
              </div>

              {/* Quote Text */}
              <blockquote className="font-body text-foreground/90 leading-relaxed mb-6 pt-4 italic">
                "{testimonial.quote}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-gold" />
                <div>
                  <p className="font-display text-sm font-semibold text-foreground">
                    {testimonial.author}
                  </p>
                  <p className="font-body text-xs text-muted-foreground">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
